import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import io from 'socket.io-client';

import LLMResponse from "~/shared/components/LLMResponse/LLMResponse";
import Citations from "~/shared/components/Citations/Citations";


const CounterspeechApp = (props) => {
    const [result, setResult] = useState();
    const [status, setStatus] = useState("Idle");
    const [selectedModel, setSelectedModel] = useState(Object.values(props.availableLlms)[0]);

    const socket = useRef();

    useEffect(() => {
        socket.current = io("/tasks", { path: props.wsRoute, transports: ["websocket", "polling"] });
        socket.current.connect();

        return () => { socket.current.disconnect(); };
    }, []);

    const generateCounterspeechText = async () => {
        const text = document.getElementById('counterspeech-text').value;
        
        if (!text) {
            alert('Please enter some text.');
            return;
        }

        const useRag = $("input[name='use-rag']").prop('checked');

        setStatus();
        setResult();
        fetch(
            props.counterspeechApiEndpoint,
            { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ "message": text, "llm": selectedModel, "use_rag": useRag }) }
        )
        .then((response) => response.json())
        .then((data) => {
            socket.current.emit('join_task', { task_id: data.task_id });
            socket.current.on("task_update", (updateData) => {
                console.log('Received update:', updateData);
                setStatus(updateData.status);
                if(updateData.status === "Error") {
                    socket.current.off("task_update");
                    socket.current.emit('leave_task', { task_id: data.task_id });
                } else if (updateData.status === "Completed") {
                    setResult({
                        generatedText: updateData.generated_text,
                        citations: updateData.citations,
                    });
                    socket.current.off("task_update");
                    socket.current.emit('leave_task', { task_id: data.task_id });
                }
            });
        });
    };

    const handleSelectModel = (event) => {
        setSelectedModel(event.target.id);
    };

    const loading = (status != "Idle") && (status != "Error") && (status != "Completed");
    
    return <form id="counterspeech-form">
        <div className = "card bg-secondary bg-opacity-75 p-4 text-light">
            <h2>Counterspeech generation</h2>
            <p className = "fst-italic">Enter text in the box below to request an AI-generated counterspeech.</p>
            <div className = "form-floating">
                <textarea
                    className = "form-control"
                    id = "counterspeech-text"
                    placeholder = "Enter text here..."
                    maxLength = { 1024 }
                    style = {{ minHeight: 100 }}
                    required
                    disabled = { loading }
                >
                    { props.counterspeechExample }
                </textarea>
                <label className = "text-muted fs-6" htmlFor="counterspeech-text">Input text</label>
            </div>
            <div className = "d-flex justify-content-evenly align-items-center my-3">
                <div className = "form-check form-switch">
                    <input className = "form-check-input" type = "checkbox" name = "use-rag" role = "switch" id = "use-rag" disabled = { loading } />
                    <label className = "form-check-label" htmlFor = "use-rag">Use RAG</label>
                </div>
                <div className = "dropdown">
                    <span className = "fw-bold">LLM<i className = "bt bi-arrow-right mx-2"></i></span>
                    <button className = "btn btn-outline-light dropdown-toggle" type = "button" data-bs-toggle = "dropdown" aria-expanded = "false">
                        { Object.entries(props.availableLlms).filter(([,id]) => selectedModel === id).map(([label,]) => label) }
                    </button>
                    <ul className = "dropdown-menu">
                        {
                            Object.entries(props.availableLlms).map(([label, id]) => <li key = { id }>
                                <a className = { `dropdown-item ${selectedModel === id ? "active" : ""}` } href = "#" id = { id } onClick = { handleSelectModel }>{ label }</a>
                            </li>)
                        }
                    </ul>
                </div>
            </div>
            <p className = "mt-3">
                {
                    loading && <div className = "llm-response">
                        <span className = "cursor" />
                        <span className = "text-muted ms-2">{ status }</span>
                    </div>
                }
                { status === "Error" && <div className = "text-center text-danger fw-bold">An error occurred with this text</div> }
                { result && <LLMResponse text = { result.generatedText } interval = { 25 } /> }
            </p>
            { result?.citations && <Citations content = { result?.citations } /> }
        </div>
        <div className = "my-3 text-center" id = "counterspeech-model">
            <button type = "button" className = { `btn btn-lg btn-outline-secondary rounded-0 ${loading && "disabled"}` } onClick = { generateCounterspeechText }>
                Generate counterspeech text
            </button>
        </div>
    </form>;
};

CounterspeechApp.propTypes = {
    wsRoute: PropTypes.string,
    counterspeechExample: PropTypes.string,
    counterspeechApiEndpoint: PropTypes.string,
    availableLlms: PropTypes.object
};

export default CounterspeechApp;